// C-3 — Vídeo-análisis en la agenda (rejilla TimeGrid). Helper compartido por la
// agenda del entrenador (MonitorAgendaPage) y la del admin (SesionesPage): mapea
// un booking AGENDADO a un evento de la rejilla, con color y testid propios que
// lo distinguen de las sesiones. Sin migración: la duración es constante cliente.

import type { TimeGridEvent } from '../components/TimeGrid';

// Duración del bloque de vídeo-análisis. La BD solo guarda `scheduled_at` (no hay
// hora de fin) y NO se añade columna: la duración es constante en cliente. Este es
// el ÚNICO sitio donde vive → cambiarla aquí si el criterio cambia.
export const VIDEO_ANALYSIS_DURATION_MIN = 60;

// Color propio del vídeo-análisis. Las sesiones usan verde/azul/naranja/amarillo
// (niveles), gris (individual) y ámbar (especial); morado los distingue de todas.
export const VIDEO_ANALYSIS_COLOR = '#A855F7';

// Prefijo del id de evento → testid `tg-event-va-<uuid>`, distinto del de las
// sesiones, y discrimina el destino del click sin depender del contenido de meta.
export const VIDEO_ANALYSIS_EVENT_PREFIX = 'va-';

// Fila mínima de `video_analysis_bookings` que necesita la agenda.
export interface VideoAnalysisBookingRow {
  id: string;
  scheduled_at: string | null;
  status: string;
  trainer_id: string | null;
  user_id: string;
}

export interface VideoAnalysisEventMeta {
  type: 'video_analysis';
  bookingId: string;
}

// Mapea un booking AGENDADO (scheduled_at NOT NULL) a un evento de la rejilla:
// start = scheduled_at; end = start + VIDEO_ANALYSIS_DURATION_MIN. Devuelve null
// si no tiene hora (los 'pending' no deben entrar; guard defensivo).
export function videoBookingToEvent(b: VideoAnalysisBookingRow): TimeGridEvent | null {
  if (!b.scheduled_at) return null;
  const start = new Date(b.scheduled_at);
  const end = new Date(start.getTime() + VIDEO_ANALYSIS_DURATION_MIN * 60_000);
  return {
    id: `${VIDEO_ANALYSIS_EVENT_PREFIX}${b.id}`,
    title: 'Vídeo-análisis',
    start,
    end,
    color: VIDEO_ANALYSIS_COLOR,
    meta: { type: 'video_analysis', bookingId: b.id } satisfies VideoAnalysisEventMeta,
  };
}

// ¿El evento de la rejilla es un vídeo-análisis? (para filtros y destino del click).
export function isVideoAnalysisEvent(e: TimeGridEvent): boolean {
  return (e.meta as VideoAnalysisEventMeta | undefined)?.type === 'video_analysis';
}

// Id del booking concreto detrás del evento (para el deep-link ?booking=<id>).
export function getVideoBookingId(e: TimeGridEvent): string | null {
  return (e.meta as VideoAnalysisEventMeta | undefined)?.bookingId ?? null;
}
